<div *ngIf="show()" class="overlay" (click)="closePopup()">
  <div class="message-popup" (click)="$event.stopPropagation()">
    <span class="close-button" (click)="closePopup()">×</span>
    <pre>{{ message() }}</pre>
  </div>
</div>
